module.exports = __webpack_public_path__ + "static/media/DiningPlaceholderImage.a3f4afc3.png";